





























































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import SkillCheckList from './SkillCheckList.vue';
import { vxm } from '@/store.vuex';
import ConfirmationModal from '@/components/Commons/ConfirmationModal.vue';
import { TranslateResult } from 'vue-i18n';
@Component({
  components: {
    SkillCheckList,
  },
})
export default class SkillCard extends Vue {
  @Prop() skills;
  $wlToastr: any;
  private editingExperienceId = 0;
  private experienceValue = '';
  private errorString: TranslateResult = '';

  get appTheme() {
    return vxm.utility.AppTheme;
  }

  userPermissionConfig(permission){
    return vxm.configs.getUserPermissionConfig(permission,'SKILLS');
  }

  setEditingExperience(skill) {
    if (skill) {
      this.editingExperienceId = skill.skillTypeId;
      this.experienceValue = skill.yearsOfExperience;
    } else {
      this.editingExperienceId = 0;
    }
  }

  async setExperience(skillId) {
    if (this.validateYearOfExperience()) {
      const payload = this.skills.map((skill) => {
        return {
          skillTypeId: skill.skillType.skillTypeId,
          primary: skill.skillType.primary || false,
          yearsOfExperience:
            skill.skillType.skillTypeId === skillId
              ? this.experienceValue
              : skill.skillType.yearsOfExperience === null
              ? '0'
              : skill.skillType.yearsOfExperience,
        };
      });
      await vxm.users.updateSkills(payload);
      vxm.users.getSkills();
      this.editingExperienceId = 0;
    }
  }

  async setPrimarySkill(skillId) {
    this.$refs['make-primary-dropdown-' + skillId][0].hide();
    const payload = this.skills.map((skill) => {
      return {
        skillTypeId: skill.skillType.skillTypeId,
        primary: skill.skillType.skillTypeId === skillId,
        yearsOfExperience: skill.skillType.yearsOfExperience,
      };
    });
    await vxm.users.updateSkills(payload);
    vxm.users.getSkills();
  }

  confirmDeleteSkill(id: number) {
    this.$modal.show(
      ConfirmationModal,
      {
        header: this.$t('skillcard-confirm-delete-skill-header'),
        body: this.$t('skillcard-confirm-delete-skill-message'),
        okText: this.$t('global.ok.text'),
        cancelText: this.$t('global.cancel-text'),
        onOk: () => {
          this.deleteSkill(id);
        },
      },
      {
        height: 'auto',
        clickToClose: false,
      },
    );
  }

  deleteSkill(skillTypeId: number) {
    const vm = this;
    const respPromise: any = vxm.skills.deleteSkill(skillTypeId);
    Promise.all([respPromise]).then((values) => {
      if (!values[0].success) {
        vm.$wlToastr('error', vm.$t('unable-to-delete-skill-err-msg'), vm.$t('skill.success.message.title'));
      } else {
        vxm.users.getProfileStrength();
        vm.$wlToastr('success', vm.$t('skill-deleted-success-msg'), vm.$t('skill.success.message.title'));
      }
    });
  }

  experienceText(yearsOfExperience = 0) {
    return this.$tc(
      'myprofile.skill.yearofexperience.text',
      yearsOfExperience,
      { yoe: yearsOfExperience },
    );
  }

  get isGuidedSignupPage() {
    var str = this.$route.path!;
    console.log('str is ', str);
    console.log('returning ', str.includes('guidedsignup'));
    return str.includes('guidedsignup');
  }

  openCheckList(skill) {
    if (this.isGuidedSignupPage) {
      console.log('opening skillcheckList');
      this.$router.push({
        name: 'GuidedSignupSkillCheckList',
        params: { skill: skill, isGuidedSignupPage: true.toString() },
      });
    } else {
      console.log('opening skillcheckList');
      this.$router.push({
        name: 'SkillCheckList',
        params: { skill: skill, isGuidedSignupPage: false.toString() },
      });
    }
  }

  validateYearOfExperience(): boolean {
    if (this.experienceValue) {
      let yoe = parseInt(this.experienceValue);
      if (yoe < this.minYearOfExperience) {
        this.errorString = this.$t(
          'myprofile.skill.yearofexperience.min.valid',
          { min_value: this.minYearOfExperience },
        );
        return false;
      } else if (yoe > this.maxYearOfExperience) {
        this.errorString = this.$t(
          'myprofile.skill.yearofexperience.max.valid',
          { max_value: this.maxYearOfExperience },
        );
        return false;
      } else {
        return true;
      }
    }
    return true;
  }

  get canShowAdvancedSettings() {
    return vxm.configs.getGlobalConfigValue('SHOW_SKILL_ADVANCED_OPTIONS');
  }

  get minYearOfExperience() {
    return 0;
  }

  get maxYearOfExperience() {
    return 100;
  }
}
